"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CopyIcon_1 = __importDefault(require("@components/CopyIcon"));
var QuickAddToList_1 = __importDefault(require("@components/QuickAddToList"));
var react_1 = __importDefault(require("react"));
function QuickActions(_a) {
    var showCopyIcon = _a.showCopyIcon, showQuickAddToList = _a.showQuickAddToList, isNotEditable = _a.isNotEditable, isReadOnlyField = _a.isReadOnlyField, domain = _a.domain, label = _a.label, value = _a.value, automationListsPermission = _a.automationListsPermission;
    return (react_1.default.createElement(react_1.default.Fragment, null, String(value) && (showCopyIcon || showQuickAddToList) && isNotEditable && (react_1.default.createElement("div", { className: "eva-job-key-value-item__icon-container" },
        showCopyIcon && react_1.default.createElement(CopyIcon_1.default, { value: String(value) }),
        showQuickAddToList && !isReadOnlyField && typeof value !== 'boolean' && (react_1.default.createElement(QuickAddToList_1.default, { domain: domain, word: String(value), label: label, automationListsPermission: automationListsPermission }))))));
}
exports.default = QuickActions;
